/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { renderInfoForType } from '../../../utils/helpers';
import styles from '../../../styles/general.module.scss';
import { INSPECTIONS } from '../../../constants/RouterConstants';

const Table = ({ info }) => (
  <table className={styles.table}>
    <thead>
      <tr>
        <th className={styles.orderNumber}>
          <FormattedMessage id="lease.inspection.table.insp_date" defaultMessage="Inspection Date" />
        </th>
        <th>
          <FormattedMessage id="lease.inspection.table.insp_type" defaultMessage="Type of Inspection" />
        </th>
        <th>
          <FormattedMessage id="lease.inspection.table.logged_by" defaultMessage="Inspected By" />
        </th>
        <th>
          <FormattedMessage id="lease.inspection.table.property" defaultMessage="Property" />
        </th>
        <th>
          <FormattedMessage id="lease.inspection.table.status" defaultMessage="Status" />
        </th>
        <th />
      </tr>
    </thead>
    <tbody>
      {!info.length > 0 ? (
        <tr>
          <td className="noTableData" colSpan={5}>
            <FormattedMessage id="lease.inspection.table.no_results" defaultMessage="There are no inspections on the selected range" />
          </td>
        </tr>
      )
        : (
          info?.map(e => (
            <tr key={e.id}>
              <td>
                {e.inspection_date && renderInfoForType({ type: 'date' }, e.inspection_date, null, null)}
                {!e.inspection_date && e.created_date && renderInfoForType({ type: 'date' }, e.created_date, null, null)}
              </td>
              <td>{e.title}</td>
              <td>{e.inspected_by?.fullname}</td>
              <td>{typeof e.property_name === 'string' && e.property_name}</td>
              <td>
                <div className={styles.active}>
                  <FormattedMessage id="lease.inspections.list.done" defaultMessage="Done" />
                </div>
              </td>
              <td>
                <Link className="link_color" to={`${INSPECTIONS}/hangar/${e.id}/detail`}>
                  <FormattedMessage id="workorders.list.table.action" defaultMessage="View" />
                </Link>
              </td>
            </tr>
          ))
        )
      }
    </tbody>
  </table>
);

Table.propTypes = {
  info: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default Table;
